import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { Row, Col, message } from 'antd';
import { Input, Select, Form, Button, Table, FooterToolbar, Status, Page, ContentWrapper, IconDelete, DatePicker, Loading } from '~/components';
import { actions, tabPanes } from '~/options';
import { MensagemService } from '~/services';
import { notifySuccess } from '~/utils';
import { focusField } from '~/utils/functions';
import './MensagemPage.less';

class MensagemPage extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      isLoadingMsg: false,
      dataItems: [],
      dataItemsRecado: [],
      dataItemsPlaca: [],
      selectedItem: {},
      action: actions.idle,
      activeTab: tabPanes.table.key,
    };
  }

  componentDidMount() {
    this.buscarRecado();
    this.buscarPlaca();
    this.searchApi.submitForm();
  }

  handleSearch = values => {
    this.setState({ isLoading: true, selectedItem: {} }, () => {
      MensagemService.getAll(
        values,
        dataItems => {
          this.setState({ dataItems, isLoading: false });
          this.searchInput.focus();
        },
        () => {
          this.setState({ isLoading: false });
        }
      );
    });
  };

  buscarRecado = () => {
    this.setState({ isLoadingMsg: true }, () => {
      MensagemService.getAll(
        { limit: 'LIMIT 5' },
        dataItemsRecado => this.setState({ dataItemsRecado, isLoadingMsg: false }, focusField(this.searchInput)),
        () => this.setState({ dataItemsRecado: [], isLoadingMsg: false }, focusField(this.searchInput))
      );
    });
  };

  buscarPlaca = () => {
    this.setState({ isLoading: true }, () => {
      MensagemService.getAllPlaca(
        dataItemsPlaca => this.setState({ dataItemsPlaca, isLoading: false }),
        () => this.setState({ dataItemsPlaca: [], isLoading: false })
      );
    });
  };

  handleSelect = record => {
    this.setState({ selectedItem: record }, () => {
      this.saveApi.reset();
      this.saveApi.setValues(record);
    });
  };

  handleEdit = action => {
    if (action === actions.insert) {
      this.saveApi.reset();
    }

    this.setState({ action, activeTab: tabPanes.record.key }, () => {
      focusField(this.editInput);
    });
  };

  onEdit = (cancel = false) => {
    let { selectedItem, activeTab } = this.state;

    if (cancel) {
      this.handleSelect(selectedItem);

      if (!selectedItem.id) {
        activeTab = tabPanes.table.key;
      }
    } else {
      this.searchApi.submitForm();
      activeTab = tabPanes.table.key;
      selectedItem = {};
    }

    this.setState({ action: actions.idle, selectedItem, activeTab });
  };

  handleSave = values => {
    const { action, selectedItem } = this.state;
    let record = {};

    this.setState({ isLoading: true });

    if (action === actions.update) {
      record = selectedItem;
    }

    MensagemService.salvar(
      { ...record, ...values },
      () => this.onSave(),
      () => this.onSave(true)
    );
  };

  onSave = (error = false) => {
    this.setState({ isLoading: false }, () => {
      if (!error) {
        const { name } = this.props;
        const { action } = this.state;
        this.buscarRecado();
        this.onEdit();
        notifySuccess({ name, action });
      }
    });
  };

  handleDelete = record => {
    this.setState({ isLoading: true }, () => {
      MensagemService.excluir(
        record,
        () => this.onDelete(),
        () => this.onDelete(true)
      );
    });
  };

  onDelete = (error = false) => {
    this.setState({ isLoading: false, selectedItem: {} });

    if (!error) {
      const { name } = this.props;

      this.buscarRecado();
      this.searchApi.submitForm();
      notifySuccess({ name, action: actions.remove });
    } else {
      message.error('Ocorreu um erro ao efetuar a operação. Tente novamente ou contate o Suporte.', 4);
    }
  };

  render() {
    const { tabId, menuId } = this.props;
    const { activeTab, selectedItem, action, isLoading, dataItems, dataItemsRecado, dataItemsPlaca, isLoadingMsg } = this.state;
    const isEdit = action !== actions.idle && !isLoading;
    const isIdle = action === actions.idle && !isLoading;

    return (
      <>
        <div className="conteudo-box mensagem">
          <div className="form borda">
            <Page
              tabbed
              tabId={tabId}
              closable={isIdle}
              activeKey={activeTab}
              onChange={activeKey => this.setState({ activeTab: activeKey })}
              footer={action !== actions.insert && selectedItem.id && <Status record={selectedItem} />}
            >
              <Page.TabPane key={tabPanes.table.key} tab={tabPanes.table.tab} disabled={action !== actions.idle} className="mensagemPage">
                <Form getApi={api => (this.searchApi = api)} onSubmit={this.handleSearch}>
                  <ContentWrapper type="search">
                    <Row gutter={4}>
                      <Col md={3}>
                        <Select label="Placa" field="placa" disabled={isLoading} dataSource={dataItemsPlaca} forwardedRef={ref => (this.searchInput = ref)} />
                      </Col>
                      <Col md={18}>
                        <Input label="Texto" field="recado" disabled={isLoading} />
                      </Col>
                      <Col md={3}>
                        <Button.Search loading={isLoading} />
                      </Col>
                    </Row>
                  </ContentWrapper>
                </Form>

                <Table
                  dataSource={dataItems}
                  rowKey="id"
                  loading={isLoading}
                  record={selectedItem}
                  onRecordChange={record => this.handleSelect(record)}
                  onRow={{ onDoubleClick: () => this.setState({ activeTab: tabPanes.record.key }) }}
                  description={item => (
                    <Row>
                      <Col span={24}>
                        <span style={{ fontSize: '0.8rem' }}>{item.mensagem}</span>
                      </Col>
                    </Row>
                  )}
                >
                  <Table.Column width="10%" title="Data" dataIndex="data" type="date" />
                  <Table.Column width="10%" title="Placa" dataIndex="placa" align="center" />
                  <Table.Column width="75%" title="Mensagem" dataIndex="recado" />
                  <Table.Column
                    width="5%"
                    title="Ações"
                    dataIndex="actions"
                    align="center"
                    exporter={false}
                    sorter={false}
                    render={(text, record) => (
                      <>
                        <IconDelete validate={{ prefix: 'a' }} prefix="a mensagem" onClick={() => this.handleDelete(record)} />
                      </>
                    )}
                  />
                </Table>
              </Page.TabPane>

              <Page.TabPane key={tabPanes.record.key} tab={tabPanes.record.tab} disabled={action === actions.idle && !selectedItem.id}>
                <Form getApi={api => (this.saveApi = api)} onSubmit={this.handleSave}>
                  <ContentWrapper type="header" color={selectedItem.data_exc && action.id === 'idle' ? actions.remove.color : action.color}>
                    <Row gutter={4}>
                      <Col md={3}>
                        <DatePicker label="Data" field="data" today disabled={!isEdit} required />
                      </Col>
                      <Col md={3}>
                        <Select
                          label="Placa"
                          field="placa"
                          dataSource={dataItemsPlaca}
                          disabled={!isEdit}
                          showSearch
                          forwardedRef={ref => (this.editInput = ref)}
                        />
                      </Col>
                      <Col md={4}>
                        <Input label="CPF / CNPJ" field="cnpj" type="cpfCnpj" disabled={!isEdit} />
                      </Col>
                      <Col md={24} span={24}>
                        <Input.TextArea
                          label="Menagem"
                          field="recado"
                          disabled={!isEdit}
                          required
                          maxLength={150}
                          rows={4}
                          placeholder="Digite a mensagem que será exibida para o motorista (máximo 150 caracteres)"
                        />
                      </Col>
                    </Row>
                  </ContentWrapper>
                </Form>
              </Page.TabPane>
            </Page>
            <FooterToolbar
              left={
                <>
                  <Button.Insert disabled={!isIdle} menuId={menuId} onClick={() => this.handleEdit(actions.insert)} />
                  <Button.Update
                    disabled={!selectedItem.id || selectedItem.data_exc || !isIdle}
                    menuId={menuId}
                    onClick={() => this.handleEdit(actions.update)}
                  />
                </>
              }
              right={
                <>
                  <Button.Cancel disabled={isIdle || isLoading} onClick={() => this.onEdit(true)} />
                  <Button.Save disabled={isIdle || isLoading} loading={action !== actions.idle && isLoading} onClick={() => this.saveApi.submitForm()} />
                </>
              }
            />
          </div>

          <div className="painel-box">
            <div className="painel">
              <div className="aviso">
                <div className="titulo">Mensagem para Motoristas</div>
                <div className="texto">Envie avisos e orientações importantes para os motoristas que passam pelos seus postos!</div>
                <div className="texto">Escolha a placa do veículo, defina o período de exibição e escreva a mensagem</div>
                <div className="texto">Máximo de 150 caracteres e período de 30 dias</div>
              </div>
            </div>

            <div className="titulo-msg">Últimas mensagens enviadas</div>

            {dataItemsRecado.length > 0 ? (
              dataItemsRecado.map(item => (
                <div className="box-msg" key={item.id}>
                  <div className="info">
                    <div className="periodo">{item.data !== '' ? moment(item.data).format('DD/MM/YYYY') : ''}</div>
                    <div className="placa">{item.placa ? `Placa: ${item.placa}` : ''}</div>
                  </div>
                  <div className="texto">{item.recado}</div>
                </div>
              ))
            ) : (
              <div className="erro-msg">{isLoadingMsg ? <Loading /> : '- Nenhuma mensagem enviada.'}</div>
            )}
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = ({ user }) => ({ user });
export default connect(mapStateToProps)(MensagemPage);
